require('@babel/polyfill');

/**
 * font face observer
 */
window.FontFaceObserver = require('fontfaceobserver');

/**
 * lodash
 */
window._ = require('lodash');

/**
 * Vue.js
 */
window.Vue = require('vue').default;

/**
 * Flare client
 */
import { flare } from '@flareapp/flare-client';
import { flareVue } from '@flareapp/flare-vue';

if (process.env.NODE_ENV === 'production' && process.env.FLARE_PUBLIC_KEY !== undefined) {
    window.Vue.use(flareVue);

    flare.sourcemapVersion = 'sourcemap';
    flare.light(process.env.FLARE_PUBLIC_KEY);
    flare.addContext('App', process.env.APP_URL !== undefined ? process.env.APP_URL : '-');
}

/**
 * Lang.js
 */
import Lang from 'lang.js';
let messages = require('./lang/messages.js');
let lang = (typeof authUser !== 'undefined') ? authUser.lang : process.env.LOCALE;

/**
 * Vuelidate
 */
let Vuelidate = require('vuelidate');
window.Vue.use(Vuelidate);

/**
 * New Vue prototype definitions
 */
Vue.prototype.$authUser = (typeof authUser !== 'undefined') ? authUser : {};
Vue.prototype.$authUser.can = (ability) => {
    return (typeof abilities !== 'undefined') ? abilities.indexOf(ability) >= 0 : false; // eslint-disable-line no-undef
};
Vue.prototype.$authUser.cannot = (ability) => {
    return (typeof authUser !== 'undefined') ? abilities.indexOf(ability) === -1 : true; // eslint-disable-line no-undef
};
Vue.prototype.$perPage = (typeof process.env.PER_PAGE !== 'undefined') ? process.env.PER_PAGE : 20;
Vue.prototype.$helper = {
    FormValidator: require('./vendor/form-validator').FormValidator,
    getDate: (date) => moment.utc(date, 'YYYY-MM-DD HH:mm').local().format('DD.MM.YYYY HH:mm'),
    getDateOnly: (date) => moment(date, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY'),
    backendDateFormat: 'YYYY-MM-DD HH:mm',
    assetUrl: (typeof assetUrl !== 'undefined') ? assetUrl : '',
    blogIntroductionUrl: (typeof blogIntroductionUrl !== 'undefined') ? blogIntroductionUrl : '',
    surveyUrlPupilStart: (typeof surveyUrlPupilStart !== 'undefined') ? surveyUrlPupilStart : '',
    surveyUrlPupilEnd: (typeof surveyUrlPupilEnd !== 'undefined') ? surveyUrlPupilEnd : '',
    userFeedbackUrl: (typeof userFeedbackUrl !== 'undefined') ? userFeedbackUrl : '',
    getPaginationData: response => ({
        lastPage: response.data.last_page,
        currentPage: response.data.current_page,
        perPage: response.data.per_page,
        total: response.data.total
    })
};
Vue.prototype.$game = {
    delay: 3000,
    getSearchGameResult (numFound, numFindable, numClicks, showHint = false) {
        let bonus = numFound === numFindable && numClicks - 2 <= numFound;

        return {
            stars: bonus ? numFound + 2 : numFound,
            bonus,
            help: showHint ? 1 : 0,
            correct: numFound,
            wrong: numFindable - numFound
        };
    },
    getMultipleChoiceResult (numCorrect, numTotalCorrect, numWrong) {
        let bonus = numCorrect === numTotalCorrect && numWrong <= 1;

        return {
            stars: bonus ? numCorrect + 2 : numCorrect,
            bonus,
            correct: numCorrect,
            wrong: numTotalCorrect - numCorrect + numWrong
        };
    },
    getMediaResult (numElements) {
        return {
            stars: numElements,
            correct: numElements,
            wrong: 0
        };
    },
    getDragDropResult (numCorrect, numWrong) {
        return {
            stars: numCorrect,
            correct: numCorrect,
            wrong: numWrong
        };
    },
    getParentPIXIContainer: (component) => {
        let parent = component.$parent;
        let container = null;

        while (parent && container === null) {
            if (parent.$options.name === 'PixiContainer') {
                container = parent.container;
            }

            parent = parent.$parent;
        }

        return container;
    }

};
Vue.prototype.$lang = new Lang({
    messages: messages,
    locale: lang
});

/**
 * ElementUI
 */
var ElementUI = require('element-ui');
var locale = require('element-ui/lib/locale/lang/' + lang).default;
Vue.use(ElementUI, { locale });

/**
 * Moment.js
 */
window.moment = require('moment');
moment.locale(lang);

/**
 * axios HTTP library
 */
window.axios = require('axios');
window.axios = window.axios.create({
    baseURL: process.env.API_URL
});

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Chart.js
 */
require('chart.js');
require('hchs-vue-charts');
Vue.use(VueCharts);

// window.Pusher = require('pusher-js');

// import Echo from 'laravel-echo';
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.PUSHER_KEY !== undefined ? process.env.PUSHER_KEY : '4312fbcc1d9064978e6b',
//     cluster: process.env.PUSHER_APP_CLUSTER !== undefined ? process.env.PUSHER_APP_CLUSTER : 'mint',
//     encrypted: process.env.PUSHER_ENCRYPTED !== undefined ? !!+process.env.PUSHER_ENCRYPTED : true,
//     wsHost: process.env.PUSHER_HOST !== undefined ? process.env.PUSHER_HOST : 'localhost',
//     wsPort: process.env.PUSHER_PORT !== undefined ? process.env.PUSHER_PORT : '6001',
//     wssHost: process.env.PUSHER_HOST !== undefined ? process.env.PUSHER_HOST : 'localhost',
//     wssPort: process.env.PUSHER_PORT !== undefined ? process.env.PUSHER_PORT : '6001',
//     httpHost: process.env.PUSHER_HOST !== undefined ? process.env.PUSHER_HOST : 'localhost',
//     httpPort: process.env.PUSHER_PORT !== undefined ? process.env.PUSHER_PORT : 6001,
//     httpsHost: process.env.PUSHER_HOST !== undefined ? process.env.PUSHER_HOST : 'localhost',
//     httpsPort: process.env.PUSHER_PORT !== undefined ? process.env.PUSHER_PORT : 6001,
//     disableStats: true
// });
